export const enum LeadEmailFormStatechartStateEnum {
  /**
   * Default idle state
   */
  idle = 'idle',

  /**
   * Sending lead
   */
  sendingLead = 'sendingLead',

  /**
   * Auto registering user
   */
  autoRegisteringUser = 'autoRegisteringUser',

  /**
   * Executing google captcha
   */
  executingCaptcha = 'executingCaptcha',
}
